import { PageTypeEnum } from 'common/enums/PageTypeEnum'

export const allowedBlogLinksPageTypes = [
  PageTypeEnum.BlogLayout,
  PageTypeEnum.BlogPostLayout,
  PageTypeEnum.BlogHome,
  PageTypeEnum.BlogStatic,
  PageTypeEnum.BlogPostListing,
  PageTypeEnum.BlogSearch,
]
